export function init( node ) {

	if ( ! node ) {
		return;
	}

	let blockStyle = node.currentStyle || window.getComputedStyle(node);

	//gutterHeight should equal double the padding of the nextBlock if padding exists OR set to 3.5rem - this is double the gutter
	let gutterHeight;

	//use gutter css variable if padding doesn't exist on element
	const defaultGutter = parseFloat(window.getComputedStyle(document.body).getPropertyValue('--wp--custom--gutter')) * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
	let topPadding = parseInt(blockStyle.paddingTop);
	let bottomPadding = parseInt(blockStyle.paddingBottom);

	if(topPadding > 0 || bottomPadding > 0) {
		gutterHeight = topPadding + bottomPadding;
	} else {
		gutterHeight = defaultGutter;
	}

	let isGreater768 = document.body.clientWidth >= 768;
	const matchMedia = window.matchMedia("(min-width: 768px)");

	matchMedia.addEventListener('change', ()=> {
		isGreater768 = document.body.clientWidth >= 768;
		blockSettings();
	});

	const blockSettings = () => {
		if(isGreater768) {
			//add gutterHeight margin bottom to nextBlock
			node.style.marginBottom = (gutterHeight * -1) + 'px';
		} else {
			node.removeAttribute('style');
		}
	}

	blockSettings();

	return node;

}


export const instances = Array.from( document.querySelectorAll( '.media-text-dynamic.has-overlap' ) ).map( init );
